import { z } from 'zod';
export const faqItemDtoSchema = z.object({
    id: z.string(),
    question: z.string(),
    answer: z.string(),
    order: z.number().int(),
    category: z.string().nullable(),
});
export const createFaqItemSchema = z.object({
    question: z.string().trim().min(2).max(200),
    answer: z.string().trim().min(2).max(4000),
    order: z.number().int().default(0),
    category: z.string().max(60).nullable().optional(),
});
